import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPaperPlane, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Button from '../ui/Button/Button';
import api from '../../services/api';
import './ContactModal.css';

/**
 * Modal de Formulário de Contato
 */
const ContactModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [validarCampos, setValidarCampos] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    email: false,
    phone: false,
    company: false
  });

  const validateRequiredFields = (nextData = formData) => {
    const nextErrors = {
      name: nextData.name.trim() === '',
      email: nextData.email.trim() === '',
      phone: nextData.phone.trim() === '',
      company: nextData.company.trim() === ''
    };

    setFieldErrors(nextErrors);

    return !Object.values(nextErrors).some(Boolean);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextData = {
      ...formData,
      [name]: value
    };

    setFormData(nextData);

    if (validarCampos) {
      validateRequiredFields(nextData);
    }
  };

  const handleClick = async () => {
    setValidarCampos(true);

    if (!validateRequiredFields()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        nome: formData.name,
        email: formData.email,
        celular: formData.phone,
        nomeloja: formData.company
      };

      const response = await api.post(
        '/leads',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      console.info('Lead gravado com sucesso:', response?.data);

      setIsSubmitting(false);
      setShowSuccessModal(true);

      setValidarCampos(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
      setFieldErrors({
        name: false,
        email: false,
        phone: false,
        company: false
      });
    } catch (error) {
      setIsSubmitting(false);

      const status = error?.response?.status;
      const responseData = error?.response?.data;

      alert(`Nao foi possivel enviar seus dados agora${status ? ` (status ${status})` : ''}. Tente novamente em instantes.`);
      console.error('Erro ao enviar formulario:', {
        status,
        responseData,
        message: error?.message,
        baseURL: api?.defaults?.baseURL,
        endpoint: '/leads'
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleClose = () => {
    setShowSuccessModal(false);
    setValidarCampos(false);
    setFieldErrors({
      name: false,
      email: false,
      phone: false,
      company: false
    });
    onClose();
  };

  const handleSuccessOk = () => {
    setShowSuccessModal(false);
    handleClose();
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-overlay" onClick={handleClose}></div>
      <div className="modal-contact">
        <button className="modal-contact__close" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {showSuccessModal ? (
          <div className="modal-contact__success">
            <div className="modal-contact__success-icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <h2>Enviado com sucesso</h2>
            <p>Perfeito! Já recebemos seus dados e, em breve, um especialista entrará em contato.</p>
            <Button
              type="button"
              variant="accent"
              size="md"
              className="modal-contact__success-ok"
              onClick={handleSuccessOk}
            >
              OK
            </Button>
          </div>
        ) : (
          <>
            <div className="modal-contact__header">
              <h2>Fale com um especialista</h2>
              <p>Preencha o formulário e retornaremos em breve com a melhor opção para sua loja</p>
            </div>

            <form className="modal-contact__form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nome Completo *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Digite seu nome"
                />
                {fieldErrors.name && <span className="form-error">Campo obrigatorio</span>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">E-mail *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="seu@email.com"
                  />
                  {fieldErrors.email && <span className="form-error">Campo obrigatorio</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Telefone *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="(00) 00000-0000"
                  />
                  {fieldErrors.phone && <span className="form-error">Campo obrigatorio</span>}
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="company">Nome da Loja *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Digite o nome da sua loja"
                />
                {fieldErrors.company && <span className="form-error">Campo obrigatorio</span>}
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Conte-nos mais sobre suas necessidades..."
                ></textarea>
              </div>

              <Button
                type="button"
                variant="accent"
                size="lg"
                fullWidth
                loading={isSubmitting}
                onClick={handleClick}
                icon={<FontAwesomeIcon icon={faPaperPlane} />}
              >
                {isSubmitting ? 'Enviando...' : 'Enviar mensagem'}
              </Button>

              <p className="form-disclaimer">
                Ao enviar este formulário, você concorda com nossa{' '}
                <a href="/politica-de-privacidade" target="_blank">Política de Privacidade</a>
              </p>
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default ContactModal;
